
<template>
<div>
<b-modal
      hide-footer
      size="md"
      centered
      ref="add-enterprise-modal"
      id="add-enterprise-modal"
      title="ADICIONAR EMPREENDIMENTO"
    >
    <template #modal-title>
      <div class="titulo-modal">ADICIONAR EMPREENDIMENTO</div>
    </template>
          <b-form-group
            id="input-group-name"
            label="Empreendimentos:"
            label-for="input-enterprise"
          >
          <select
           id="input-uf-creci"
           class="form-control"
           v-model="empreedimentoId"
           placeholder="Selecione o empreendimento"
            >
              <option disabled selected :value="''">Selecione o empreendimento</option>
              <option :class="{'teste':true,'agua':true}" class="ssss" v-for="data in enterprise" :key="data.value" :value="data.value" >{{data.text}}</option>
          </select>
          </b-form-group>

         <div class="container-buttons-form pt-3">
            <button @click="cancelNewEnterprise" class="button-cancel">
              Cancelar
            </button>
            <button class="button-save" @click="onSubmit">Salvar</button>
          </div>
  </b-modal>
</div>

</template>

<script>
import Toaddenterprise from './toaddenterprise'
export default Toaddenterprise

</script>

<style scoped>

#add-new-user{
    font-size: 28px;
    background-color: #008144;
    outline: transparent;
    color:white;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border:transparent
}

#body-poup{
  display: flex;
  width: 50%;
  justify-content: center;
  align-items: center;
}

#input-group-name{
    grid-row: 4;
    grid-column: 1/5;
    align-items: center;
    align-content: center;
    justify-content: center;
    position: relative
}

.titulo-modal{
    color:white;
    font: normal normal 600 18px/24px Segoe UI;
    display: flex;
    align-items: center;
}
.button-cancel{
    background-color: #dedede;
    color: #747474;
}

.button-save{
    background-color: #008148;
    color: white;
}

#input-group-enterprise{
    width: 60%;
    margin-left: 20%;
    margin-bottom: 5%;
}
.container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.button-cancel,.button-save{
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/accredited/components/toaddenterprise/toaddenterprise.vue